/* istanbul ignore file */
export enum HMRoutingPaths {
  overview = 'overview',
  candidatePipeline = 'candidatePipeline',
  candidateProfile = 'candidateProfile',
}
